import { decisionCardResolution } from '@lc/const/turnTypes';
import { controller_card } from '@lc/controller/card';
import { GameState } from '@lc/interface/gameState/types';
import { isContractDue } from '@lc/lib/gamestate_helper';
import { getPlayerStateWithId } from '@lc/lib/player_helper';

class TimelineResolution {
	activeContractAwardResolution = (
		gameState: GameState,
		ticker: string[]
	) => {
		console.log('activeContractAwardResolution');

		for (const playerTurnId of gameState.currentTurnTypePlayerTableOrder) {
			console.log(
				'Resolving contracts and awards in turn order for player with id: ' +
					playerTurnId
			);
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerTurnId
			);

			console.log('TESTING PLAYER STATE VALUES');
			console.log(pState);

			const { pId, cId } = this.resolveAwardsAndContractsForPlayerId(
				playerTurnId,
				pState.activeContractsAndAwards,
				gameState,
				ticker
			);

			if (pId !== -1 && cId !== -1) {
				ticker.unshift(
					`Player ${pId} completed Card Id ${cId} and is requested to make a decision`
				);
				gameState.turnType = decisionCardResolution;
				gameState.activePlayerId = pId;
				gameState.decisionCardId = cId;
				return true;
			}
		}
		return false;
	};

	// How do I skip asking for summit cards? I guess after I ask player on
	// final turn of resolving contracts and awards (just last pass ask of player when they have no cards to resolve)
	// just delete their summit cards or use the "NO SUMMIT CARDS" boolean you'd use with flat earth contract
	activeContractAwardResolutionWinter = async (
		gameState: GameState,
		ticker: string[]
	) => {
		for (const playerTurnId of gameState.currentTurnTypePlayerTableOrder) {
			console.log(
				'Resolving turn order for player with id: ' + playerTurnId
			);
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerTurnId
			);

			const { pId, cId } = this.resolveAwardsAndContractsForPlayerId(
				playerTurnId,
				pState.activeContractsAndAwards,
				gameState,
				ticker
			);
			if (pId !== -1 && cId !== -1) {
				ticker.unshift(
					`Player ${pId} completed Card Id ${cId} and is requested to make a decision`
				);
				gameState.turnType = decisionCardResolution;
				gameState.activePlayerId = pId;
				gameState.decisionCardId = cId;
				return true;
			}
		}
		return false;
	};

	// See if card requires a decision
	// if no, resolve and move on to the next one
	// if it requires a decision, return cardId and playerId
	// send to player
	// when decision is sent back to server, resolvePlayerDecision() will remove the card from the contract and award array
	// this will allow resolveAwardsAndContractsForPlayerId() to move forward to the next applicable contract/award
	resolveAwardsAndContractsForPlayerId = (
		playerId: number,
		activeContractsAndAwards: number[],
		gameState: GameState,
		ticker: string[]
	) => {
		console.log('resolveAwardsAndContractsForPlayerId');
		console.log(activeContractsAndAwards);
		for (let z = activeContractsAndAwards.length - 1; z >= 0; z--) {
			const { pId, cId } = this.resolveAwardOrContractDecisionCheck(
				playerId,
				z,
				activeContractsAndAwards,
				gameState,
				ticker
			);
			if (pId > -1 || cId > -1) {
				return { pId, cId };
			}
		}
		return { pId: -1, cId: -1 };
	};

	/**
	 * Branches between:
	 *  AWARD:
	 *      1) requires a decision from winner
	 *      2) Nobody won, discard Award
	 *  CONTRACT:
	 *      1) Resolve if penalty
	 * */
	resolveAwardOrContractDecisionCheck(
		playerId: number,
		index: number,
		activeContractsAndAwards: number[],
		gameState: GameState,
		ticker: string[]
	) {
		console.log('resolveAwardOrContractDecisionCheck');
		const cardId = activeContractsAndAwards[index];
		const currCard = controller_card.getCurrCard(cardId) as any;
		console.log('CURR CARD');
		console.log(currCard);
		if (currCard.requireDecision === true) {
			console.log('card requires decision');
			const winnerId = currCard.determineWinnerId(
				{ playerId },
				gameState
			);

			console.log('winnerId');
			console.log(winnerId);

			if (winnerId >= 0) {
				currCard.decisionPrep({ playerId, winnerId }, gameState);
				return { pId: winnerId, cId: cardId };
			}

			activeContractsAndAwards.splice(index, 1); // Nobody won. Removes card from player's active contract and awards
		} else {
			this.resolveAwardOrContractAndRemove(
				playerId,
				index,
				activeContractsAndAwards,
				gameState,
				ticker
			);
		}
		return { pId: -1, cId: -1 };
	}

	resolveAwardOrContractAndRemove(
		playerId: number,
		index: number,
		activeContractsAndAwards: number[],
		gameState: GameState,
		ticker: string[]
	) {
		console.log('resolveAwardOrContractAndRemove');
		const cardId = activeContractsAndAwards[index];
		const currCard = controller_card.getCurrCard(cardId) as any;
		// card can be resolved, doesn't require decision
		if (currCard.type === 'Award') {
			this.resolveAward(playerId, cardId, currCard, gameState, ticker);
			activeContractsAndAwards.splice(index, 1); // Removes award from player's active contract and awards
		} else if (
			currCard.type === 'Contract' &&
			isContractDue(currCard, gameState)
		) {
			this.resolveContract(playerId, cardId, currCard, gameState, ticker);
			activeContractsAndAwards.splice(index, 1); // Removes contract from player's active contract and awards
		}
		// no action taken, ignore card
	}

	resolveAward(
		playerId: number,
		cardId: number,
		currCard: any,
		gameState: GameState,
		ticker: string[]
	) {
		console.log('resolveAward');
		const winnerId = currCard.determineWinnerId({ playerId }, gameState);
		if (winnerId !== -1) {
			console.log(`Player ${winnerId} won Award with Card Id ${cardId}`);
			ticker.unshift(
				`Player ${winnerId} won Award with Card Id ${cardId}`
			);
			currCard.action({ playerId }, gameState); // need to point to original award owner so prizes are distributed appropriately

			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				winnerId
			);

			pState.completedAwards.push(cardId);
			pState.completedContractsAndAwards.push(cardId);
		} else {
			gameState.discardPile.push(cardId);
			ticker.unshift(`No Player won Award with Card Id ${cardId}`);
		}
	}

	// Contract is due. did player succeed or fail contract
	// PASS: add completed contract to player completedContract array
	// FAIL: run penalty function and add contract to player failedContract array
	resolveContract(
		playerId: number,
		cardId: number,
		currCard: any,
		gameState: GameState,
		ticker: string[]
	) {
		console.log('resolveContract');
		const isContractComplete = currCard.actionCondition(
			{ playerId },
			gameState
		);

		if (playerId !== -1) {
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerId
			);

			if (isContractComplete) {
				ticker.unshift(
					`Player ${playerId} won Contract with Card Id ${cardId}`
				);
				pState.completedContracts.push(cardId);
				pState.completedContractsAndAwards.push(cardId);
			} else {
				currCard.actionPenalty({ playerId }, gameState);
				ticker.unshift(
					`Player ${playerId} lost Contract with Card Id ${cardId}`
				);

				pState.failedContracts.push(cardId);
			}
		}
	}
}

export const timeline_resolution = new TimelineResolution();
